import { Validation } from "./Validation";

/**
 * Sepa Lastschriftmandat eines Kunden
 */
export default interface SepaMandateJson {
   ID: number | null;

   /**
    * Datum an dem das SEPA-Mandat angenommen wurde. Der Client kann hier einfach das heutige Datum automatisch eintragen.
    * Wird vom Server ohnehin dann überschrieben mit dem aktuellem Datum.
    */
   dateTime: string;

   /**
    * Datum an dem das SEPA-Mandat erstellt oder zuletzt verwendet wurde.
    */
   lastUseDateTime: string,

   accountHolderFirstName: string;
   accountHolderLastName: string;

   addressStreet: string;
   addressZip: string;
   addressCity: string;
   addressCountry: string;

   IBAN: string;
   BIC: string;
}

export function defaultSepaMandateJson(): SepaMandateJson {
   return {
      ID: null,
      dateTime: new Date().toISOString(),
      lastUseDateTime: new Date().toISOString(),
      accountHolderFirstName: "",
      accountHolderLastName: "",
      addressStreet: "",
      addressZip: "",
      addressCity: "",
      addressCountry: "",
      IBAN: "",
      BIC: "",
   };
}

export function validateSepaMandate(item: SepaMandateJson) {
   return new Validation(item)
      .validateDate("dateTime")
      .validateNonEmptyString("accountHolderFirstName", 100)
      .validateNonEmptyString("accountHolderLastName", 100)
      .validateNonEmptyString("addressStreet", 100)
      .validateNonEmptyString("addressZip", 100)
      .validateNonEmptyString("addressCity", 100)
      .validateNonEmptyString("addressCountry", 100)
      .validateIBAN("IBAN")
      .validateBIC("BIC")
      .finish();
}

export function validateSepaMandateAddNew(item: SepaMandateJson) {
   return new Validation(item)
      .validateEquals("ID", null)
      .validateDate("dateTime")
      .validateNonEmptyString("accountHolderFirstName", 100)
      .validateNonEmptyString("accountHolderLastName", 100)
      .validateNonEmptyString("addressStreet", 100)
      .validateNonEmptyString("addressZip", 100)
      .validateNonEmptyString("addressCity", 100)
      .validateNonEmptyString("addressCountry", 100)
      .validateIBAN("IBAN")
      .validateBIC("BIC")
      .finish();
}